import React from 'react';

export const PoweredByPaxfidely = ({ hotelId, isWhiteLabel }) => {
  if (isWhiteLabel) return null;

  const referralLink = hotelId 
    ? `https://paxfidely.com/onboarding?ref=${hotelId}`
    : 'https://paxfidely.com';

  return (
    <div className="w-full flex justify-center items-center py-6 mt-auto border-t border-zinc-100/10">
      <a
        href={referralLink}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[11px] font-medium tracking-widest text-zinc-500 hover:text-zinc-400 uppercase transition-all duration-300 ease-in-out opacity-60 hover:opacity-100 flex items-center gap-1"
      >
        <span>Powered by</span>
        <span className="font-bold text-zinc-600 hover:text-zinc-300 tracking-normal normal-case">
          PAXFIDELY
        </span>
      </a>
    </div>
  );
};